module.exports = __webpack_public_path__ + "static/media/FLIP 5.c2145da9.jpg";